import React from 'react';
import { useIntl } from 'react-intl';
import { ModalBody, ModalFooter } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons/faCircleInfo';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../../common/views/SMLButton/SMLButton';
import { FormLabel } from '../../forms/components/FormLabel/FormLabel';
import { TrackSearchField } from '../../music24/components/SearchField/TrackSearchField';
import { MeiliTrackData } from '../../music24/components/SearchField/types';
import { withBrandWord } from '../../music24/components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from './Catalog.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ClaimSearchStepProps {
  onAddUnreleased: () => void;
  onTrackPicked: (track: MeiliTrackData) => void;
  onAddRelease: () => void;
  closeModal: () => void;
}

/** Step one: find the release in the public catalog. */
const ClaimSearchStepComponent: React.FC<ClaimSearchStepProps> = ({
  onTrackPicked,
  onAddRelease,
  onAddUnreleased,
  closeModal,
}) => {
  const intl = useIntl();

  return (
    <>
      <ModalBody>
        <FormLabel>
          {intl.formatMessage({
            id: 'app.sml.catalog.claim.search_label',
            defaultMessage: 'Find it in our catalog',
          })}
        </FormLabel>
        <div className="mb-3">
          <TrackSearchField
            autoFocus
            placeholder={intl.formatMessage({
              id: 'app.sml.catalog.claim.search_placeholder',
              defaultMessage: 'Search by track or artist name',
            })}
            onTrackSelected={onTrackPicked}
          />
        </div>
        <div className={styles.infoBox}>
          <FontAwesomeIcon icon={faCircleInfo} />
          <p>
            {withBrandWord(
              intl.formatMessage({
                id: 'app.sml.catalog.claim.search_help',
                defaultMessage:
                  'No account needed. Claiming tells MUSIC24 which releases are yours, so they show up when you build a smartlink. It does not touch the release or the service.',
              })
            )}
          </p>
        </div>
      </ModalBody>
      <ModalFooter className={styles.claimFooter}>
        <SMLButton color="link" onClick={onAddRelease}>
          {intl.formatMessage({
            id: 'app.sml.catalog.claim.not_found_cta',
            defaultMessage: "I couldn't find my track",
          })}
        </SMLButton>
        <SMLButton color="link" onClick={onAddUnreleased}>
          {intl.formatMessage({
            id: 'app.sml.catalog.claim.add_prerelease',
            defaultMessage: 'Add pre-release',
          })}
        </SMLButton>
        <SMLButton outline onClick={closeModal}>
          {intl.formatMessage({ id: 'app.forms.buttons.cancel.label', defaultMessage: 'Cancel' })}
        </SMLButton>
      </ModalFooter>
    </>
  );
};

export const ClaimSearchStep = TypedMemo(ClaimSearchStepComponent);
